export interface AlainSGConfig {
  /**
   * é´è·ï¼é»è®¤ï¼`32`
   */
  gutter?: number;
  /**
   * åæ°ï¼é»è®¤ï¼`2`
   */
  col?: number;
}
